import { Injectable } from '@angular/core';

import { EventParticipant } from '@frontend/sports/betting-offer/feature/model';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { DropdownOption } from '../../dropdown/models';
import { EventDetailsType, MultiColumnDropdownOption, TrackingModel } from './scorecast-option-group.model';

@Injectable({ providedIn: 'root' })
export class ScorecastService {
    private readonly trackingNotApplicable = 'not applicable';

    constructor(private trackingService: TrackingService) {}

    getDefaultScores(teams: EventParticipant[]): MultiColumnDropdownOption[] {
        return [
            {
                id: 'home',
                name: '1',
                payload: this.generateScores(4, 'home'),
            },
            {
                id: 'draw',
                name: 'X',
                payload: this.generateScores(4, 'draw'),
            },
            {
                id: 'away',
                name: '2',
                payload: this.generateScores(4, 'away'),
            },
        ];
    }

    private generateScores(max: number, type: 'home' | 'away' | 'draw'): DropdownOption[] {
        const scores: DropdownOption[] = [];

        for (let i = 1; i <= max; i++) {
            if (type === 'draw') {
                scores.push({ id: `${i}-${i}`, name: `${i}-${i}`, disabled: true });
                continue;
            }

            if (type === 'home') {
                for (let j = 0; i > j; j++) {
                    scores.push({ id: `${i}-${j}`, name: `${i}-${j}`, disabled: true });
                }
            }

            if (type === 'away') {
                for (let j = 0; i > j; j++) {
                    scores.push({ id: `${j}-${i}`, name: `${j}-${i}`, disabled: true });
                }
            }
        }

        return scores;
    }

    trackSelect(selection: string, eventDetails: EventDetailsType, period: string): void {
        this.track({
            positionEvent: selection,
            actionEvent: 'select',
            urlClicked: this.trackingNotApplicable,
            locationEvent: period,
            eventDetails,
        });
    }

    trackClick(eventDetails: EventDetailsType, period: string): void {
        this.track({
            actionEvent: 'click',
            positionEvent: this.trackingNotApplicable,
            urlClicked: this.trackingNotApplicable,
            locationEvent: period,
            eventDetails,
        });
    }

    private track(trackModel: TrackingModel): void {
        const trackingData = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'scorecast',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'scorecast',
            [trackingConstants.COMPONENT_ACTION_EVENT]: trackModel.actionEvent,
            [trackingConstants.COMPONENT_POSITION_EVENT]: trackModel.positionEvent,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: trackModel.locationEvent,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: trackModel.eventDetails,
            [trackingConstants.COMPONENT_URL_CLICKED]: this.trackingNotApplicable,
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }
}
